import { render, staticRenderFns } from "./table-head-goal-setting.component.vue?vue&type=template&id=446e7f57&scoped=true"
import script from "./table-head-goal-setting.component.vue?vue&type=script&lang=ts"
export * from "./table-head-goal-setting.component.vue?vue&type=script&lang=ts"
import style0 from "./table-head-goal-setting.component.vue?vue&type=style&index=0&id=446e7f57&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446e7f57",
  null
  
)

export default component.exports